import { memo, useEffect, useRef } from "react";

import useConsent from "@/hooks/useConsent";
import useCookiebotLoader from "@/hooks/useCookiebotLoader";
import { useLocalization } from "@/hooks/useLocalization";
import { lazyWithPreload } from "@/utils/lazyPreload";

import { APP_CONTAINER_ID } from "./constants/elementsIds";
import { useBlockHorizontalSwipe } from "./hooks/useSwipe";
import switchLanguage from "./utils/switchLanguage";

import "./App.css";

const Router = lazyWithPreload(() => import("@/components/Router"));

const App = () => {
    const appContainerRef = useRef<HTMLDivElement | null>(null);

    useCookiebotLoader();
    switchLanguage();
    useBlockHorizontalSwipe();
    useLocalization();
    useConsent();

    const changeContainerHeight = () => {
        let height = window.innerHeight;

        if (window.visualViewport) {
            height = window.visualViewport.height;
        }

        const appContainerRef = document.getElementById(APP_CONTAINER_ID);
        if (appContainerRef) {
            appContainerRef.style.cssText = `--zing-window-height: ${height}px`;
        }
    };

    useEffect(() => {
        changeContainerHeight();
        // TODO: implement debounce here
        window.addEventListener("resize", changeContainerHeight);
        window.visualViewport?.addEventListener("resize", changeContainerHeight);

        return () => {
            window.removeEventListener("resize", changeContainerHeight);
            window.visualViewport?.removeEventListener("resize", changeContainerHeight);
        };
    }, []);

    return (
        <div
            ref={appContainerRef}
            id={APP_CONTAINER_ID}
            className="zing-screen overflow-auto overscroll-none scroll-smooth font-outfit-zing"
        >
            <Router />
            <div
                id={"preload-checkout-container-paypal"}
                className={"palta-payment-container hidden h-0"}
            ></div>
            <div
                id={"preload-checkout-container-card"}
                className={"palta-payment-container hidden h-0"}
            ></div>
            <div
                id={"preload-checkout-container-apple"}
                className={"palta-payment-container hidden h-0"}
            ></div>
        </div>
    );
};

export default memo(App);
